import moment from "moment";
import { get, post, patch } from "superagent";
import Store from "../store";
import AccountService from "./accountService";
import ErrorService from "./errorService";

var store = new Store();

var ServiceBase = function(endpoint) {
  this.endpoint = endpoint;

  var hasError = function(err, res, rej) {
    if (!err && res && res.status < 400) return false;
    // 401, 403のときは特別対応
    if (err.status == 401 || err.status == 403) {
      AccountService.logout(() => {});
      var ev = new Event("noAuthError");
      window.dispatchEvent(ev);
      return true;
    }
    var code = "";
    try {
      if (res && res.text) {
        code = JSON.parse(res.text).traceId;
      } else if (err.rawResponse) {
        // jsonでパースできないので強引に取得する。
        code = err.rawResponse
          .match(/"traceId":"[0-9:A-Z]+"/)[0]
          .replace(/"/g, "")
          .replace(/traceId:/g, "");
      }
    } catch (e) {
      // 失敗時考慮しない
    }
    // 失敗時の処理が登録されていない場合は、エラー画面に飛ばす
    if (!rej) ErrorService.throwError(err.message, err.status, code);
    return true;
  };

  /**
   * クレデンシャル情報を確認して、リクエストを送付する。
   *
   * @param {Action} req
   */
  var checkExpires = function(req, ishandleError) {
    return new Promise(function(resolve, reject) {
      const currentToken = store.token;
      // 現在時刻より五分前を期限とする
      var tokenLimit = moment(new Date())
        .add(5, "m")
        .toDate();
      if (!currentToken || new Date(currentToken.expiresOn) < tokenLimit) {
        AccountService.login(
          newToken => {
            var ev = new Event("reLogined");
            window.dispatchEvent(ev);
            req(newToken, resolve, reject);
          },
          () => {
            var ev = new Event("noAuthError");
            window.dispatchEvent(ev);
          }
        );
      } else {
        req(currentToken, resolve, ishandleError ? reject : null);
      }
    });
  };

  /**
   * queryを指定してGETリクエストを。
   *
   * @param {Object} query
   */
  this.get = function(query, ishandleError) {
    var _this = this;
    return checkExpires((token, resolve, reject) => {
      get(_this.endpoint)
        .query(query)
        .set("Authorization", "Bearer " + token.accessToken)
        .set("accept", "json")
        .end((err, res) => {
          if (hasError(err, res, reject)) reject ? reject(res) : () => {};
          else resolve(res.text ? JSON.parse(res.text) : res.text);
        });
    }, ishandleError);
  };
  this.post = function(contents, ishandleError) {
    var _this = this;
    return checkExpires((token, resolve, reject) => {
      post(_this.endpoint)
        .send(contents)
        .set("Authorization", "Bearer " + token.accessToken)
        .set("accept", "json")
        .end((err, res) => {
          if (hasError(err, res, reject)) reject ? reject(res) : () => {};
          else resolve(res.text ? JSON.parse(res.text) : res.text);
        });
    }, ishandleError);
  };
  this.patch = function(id, contents, query, ishandleError) {
    var _this = this;
    var queryStr = "";
    for (var key in query) {
      queryStr += key + "=" + query[key];
    }
    return checkExpires((token, resolve, reject) => {
      patch(_this.endpoint + "/" + id + (queryStr ? "?" + queryStr : ""))
        .send(contents)
        .set("Authorization", "Bearer " + token.accessToken)
        .set("accept", "json")
        .end((err, res) => {
          if (hasError(err, res, reject)) reject ? reject(res) : () => {};
          else resolve(res.text ? JSON.parse(res.text) : res.text);
        });
    }, ishandleError);
  };
  this.delete = function(id, query, ishandleError) {
    var _this = this;
    return checkExpires((token, resolve, reject) => {
      delete (_this.endpoint + "/" + id)
        .query(query)
        .set("Authorization", "Bearer " + token.accessToken)
        .set("accept", "json")
        .end((err, res) => {
          if (hasError(err, res, reject)) reject ? reject(res) : () => {};
          else resolve(res.text ? JSON.parse(res.text) : res.text);
        });
    }, ishandleError);
  };
};
export default ServiceBase;
